<div
    #topbarRoot
    class="fixed left-1/2 -translate-x-1/2 z-50 bg-white/60 dark:bg-[#111111cc] backdrop-blur-md border border-white/20 shadow-xl rounded-2xl px-6 py-4 w-[96vw] will-change-transform"
    style="top: calc(env(safe-area-inset-top, 0px) + 1rem); transform: translate3d(-50%, 0, 0)"
>
    <div class="layout-topbar">
        <div class="layout-topbar-logo-container">
            <button type="button" class="layout-topbar-action" (click)="toggleDarkMode()">
                <i [ngClass]="{ 'pi ': true, 'pi-moon': layoutService.isDarkTheme(), 'pi-sun': !layoutService.isDarkTheme() }"> </i>
            </button>
            <a class="layout-topbar-logo" [routerLink]="['/', currentSystem]">
                <div class="absolute left-1/2 -translate-x-1/2 top-full -translate-y-[80%] logo-wrapper">
                    <div class="logo-inner bg-white dark:bg-gray-800 rounded-full overflow-hidden w-24 h-24 p-4 shadow-lg border border-gray-300 dark:border-gray-700 flex items-center justify-center">
                        <app-img
                            [src]="topbarLogoUrl"
                            [width]="168"
                            [height]="200"
                            alt="Logo optimizado"
                            [priority]="true"
                            imgClass="w-full h-full object-contain"
                        />
                    </div>
                </div>
                <span class="hidden lg:inline-block relative group ml-4" style="font-family: 'Montserrat', sans-serif; font-weight: 600; font-size: 1.25rem; letter-spacing: -0.05em">
                    {{ sdTitle }}
                    <span class="absolute left-full top-1/2 -translate-y-1/2 ml-2 whitespace-nowrap reveal-text" style="font-family: 'Montserrat', sans-serif; font-weight: 600; font-size: 0.9rem; letter-spacing: -0.05em">
                        {{ fullSubtitle }}
                    </span>
                </span>
            </a>
        </div>

        <div class="layout-topbar-actions">
            <div class="layout-config-menu">
                <div class="block lg:hidden">
                    <p-menu #userMenuMobile [popup]="true" [model]="userMenuItems" [appendTo]="'body'"></p-menu>
                    <!-- Topbar (mobile) -->
                    <button type="button" class="layout-topbar-action layout-menu-button" data-sidebar-toggle (click)="toggleMobileMenu($event)" (touchstart)="toggleMobileMenu($event)">
                        <i class="pi pi-bars"></i>
                    </button>
                </div>
            </div>

            <div class="layout-topbar-menu hidden lg:block">
                <div class="layout-topbar-menu-content">
                    <div class="relative layout-topbar-action-wrapper group">
                        <button class="layout-topbar-action uppercase font-semibold text-sm" (click)="toggleMegaMenu()">
                            <i class="pi pi-cog"></i>
                        </button>

                        @if (megaMenuVisible) {
                            <div class="mega-fade absolute backdrop-blur-3xl top-full right-0 mt-5 z-50 p-6 rounded-2xl shadow-xl min-w-[850px] bg-white/90 dark:bg-zinc-900">
                                <div class="grid gap-6 lg:grid-cols-[minmax(0,1fr)_260px] items-start">
                                    <div>
                                        @if (menuLoading) {
                                            <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
                                                <div class="h-12 bg-gray-200 dark:bg-zinc-800 rounded-xl animate-pulse"></div>
                                                <div class="h-12 bg-gray-200 dark:bg-zinc-800 rounded-xl animate-pulse"></div>
                                                <div class="h-12 bg-gray-200 dark:bg-zinc-800 rounded-xl animate-pulse"></div>
                                            </div>
                                        } @else if (allMenuItems.length) {
                                            <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
                                                @for (item of allMenuItems; track item.id) {
                                                    <a [routerLink]="item.linkAbs || ['/']" (click)="startCloseTimer()" class="flex items-center gap-3 cursor-pointer hover:text-primary transition">
                                                        <span class="bg-[#D4A520] text-white w-12 h-12 rounded-full flex items-center justify-center">
                                                            <i class="{{ item.icon }}"></i>
                                                        </span>
                                                        <span>
                                                            <div class="font-semibold text-sm">{{ item.label }}</div>
                                                            <div class="text-xs text-gray-500">{{ item.subtext }}</div>
                                                        </span>
                                                    </a>
                                                }
                                            </div>
                                        } @else {
                                            <div class="text-sm text-gray-500">No hay elementos para mostrar.</div>
                                        }
                                    </div>

                                    <div class="flex flex-col gap-2 items-center">
                                        <img
                                            src="assets/images/cards-images/historicos/historico_1.jpg"
                                            class="w-full rounded-xl shadow max-w-[350px] max-h-[190px] object-cover"
                                            alt="Panel de control"
                                            loading="lazy"
                                            decoding="async"
                                            width="700"
                                            height="380"
                                        />
                                        <span class="text-sm text-gray-500 text-center">Todo lo que necesitás, en un solo lugar.</span>
                                        <button pButton label="CONOCENOS" href="https://blistertechnologies.com" target="_blank" [outlined]="true" class="w-full" (click)="startCloseTimer()"></button>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>

                    <div class="layout-topbar-action-wrapper">
                        <button #btnNotificaciones type="button" class="layout-topbar-action" (click)="onToggleNotificaciones($event, popover)">
                            <i class="pi pi-bell"></i>
                            @if (notificacionesNoLeidas > 0) {
                                <span class="notif-bell-badge" [attr.aria-label]="notificacionesNoLeidas + ' notificaciones sin leer'">
                                    {{ notificacionesNoLeidas > 99 ? '99+' : notificacionesNoLeidas }}
                                </span>
                            }
                        </button>

                        <p-popover #popover [dismissable]="true" [appendTo]="'body'" [style]="{ width: '380px' }">
                            <ng-template pTemplate="content">
                                <app-notifications-panel [notificaciones]="ultimasNotificaciones" (onMarcarLeida)="actualizarNotificacion($event)" (onMarcarTodasLeidas)="marcarTodasLeidas()" (onVerTodas)="verTodas()"> </app-notifications-panel>
                            </ng-template>
                        </p-popover>
                    </div>

                    <p-popover #userPopover [appendTo]="'body'" [dismissable]="true" [style]="{ width: '320px' }">
                        <ng-template pTemplate="content">
                            <div class="flex items-center gap-3 pb-3 border-b border-gray-200 dark:border-gray-700">
                                <div class="w-12 h-12 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center font-semibold overflow-hidden">
                                    @if (topbarAvatarUrl) {
                                        <img [src]="topbarAvatarUrl" alt="Avatar" class="w-full h-full object-cover" style="display:block" />
                                    } @else {
                                        {{ getUserInitials() }}
                                    }
                                </div>
                                <div class="min-w-0">
                                    <div class="font-semibold text-gray-900 dark:text-white truncate">
                                        {{ getUserDisplayName() }}
                                    </div>
                                    <div class="text-xs text-gray-500 dark:text-gray-400 truncate">
                                        {{ getUserUsername() }}
                                    </div>
                                    <div class="text-[11px] text-gray-400 dark:text-gray-500 truncate">
                                        {{ getUserDescription() }}
                                    </div>
                                </div>
                            </div>

                            <div class="mt-3 space-y-1">
                                @for (item of userMenuItems; track item.label) {
                                    <button
                                        type="button"
                                        class="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-zinc-800 transition"
                                        (click)="onUserMenuAction(item)"
                                    >
                                        <i class="{{ item.icon }}"></i>
                                        <span>{{ item.label }}</span>
                                    </button>
                                }
                            </div>
                        </ng-template>
                    </p-popover>
                    <button type="button" class="layout-topbar-action" (click)="userPopover.toggle($event)">
                        @if (topbarAvatarUrl) {
                            <div class="layout-topbar-avatar" style="display:inline-flex">
                                <img [src]="topbarAvatarUrl" alt="Avatar" style="display:block;width:100%;height:100%;object-fit:cover" />
                            </div>
                        } @else {
                            <i class="pi pi-user"></i>
                        }
                        <span>Perfil</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
